/* eslint-disable */
import requestRaw from '@/utils/requestRawBasic'
import { APICore } from '@/utils/servicesApi'

export function requestForgot(data) {
  return requestRaw({
    url: APICore() + '/member/forgot/request',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function checkForgot(data) {
  return requestRaw({
    url: APICore() + '/member/forgot/check',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function updatePasswordForgot(data) {
  return requestRaw({
    url: APICore() + '/member/forgot/update-password',
    method: 'POST',
    data: data // untuk array data post
  })
}


// WEBPACK FOOTER //
// ./src/api/forgot.js